import * as actionTypes from "./actionTypes";

export const getListGameAction = () => ({
	type: actionTypes.GET_LIST_GAME_ACTION
});

export const setListGameAction = params => ({
	type: actionTypes.SET_LIST_GAME_ACTION,
	params
});
